import { render, staticRenderFns } from "./UserContactForm.vue?vue&type=template&id=3d6cd655&scoped=true"
import script from "./UserContactForm.vue?vue&type=script&lang=ts"
export * from "./UserContactForm.vue?vue&type=script&lang=ts"
import style0 from "./UserContactForm.vue?vue&type=style&index=0&id=3d6cd655&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6cd655",
  null
  
)

export default component.exports